import '../style/applicationPolicy.css';
import Notification from "./notification";
import OverlayIndicator from "./General/overlayIndicator";
import { UI_LIB_TABLE_VIEW_OPTIONS } from "../helpers/variables";
import Loader from "./General/loader/loader";
import CONTENT_STRINGS from "../helpers/contentStrings";
import { FormGroup, Heading, Button, Pager, HorizontalRule } from 'arag-ui-lib';
import { HEADING_2, PRIMARY, QUATERNARY, RIGHT, DOTTED } from '../helpers/constants';
import { FORM_GROUP_VARIANTS } from "../helpers/formGroupVariants";

const Notifications = (props) => {
	const {
		containerRef,
		onNotificationClick,
		fetchingApplicationStatuses,
		fetchingCaseTypes,
		fetchingUpdateFormQuestions,
		selectNotificationTypes,
		shouldDisplayUpdateFormQuestionsFilter,
		clearNotificationsFilters,
		handleFilterClick,
		selectCaseTypes,
		selectApplicationStatus,
		selectUpdateFormQuestions,
		getNotificationStatusText,
		Store,
		goAtPrevious,
		goAtNext,
		goAtStart,
		goAtEnd,
		goAtPage,
		HandleInputChange,
		caseTypesOptions,
		statusesOptions,
		notificationTypesOptions,
		updateFormQuestionOptions,
		totalDisplayBoxes,
		isAragUser,
	} = props;
	return (
		<div className="row applicationsAndPolicies-wrapper" ref={containerRef}>
			<div className="col-sm-12">
				<Heading
					variant={HEADING_2}
					title={CONTENT_STRINGS.NOTIFICATIONS}
					headingTestId={'notifications-header'}
				/>
				<form className="form-horizontal applicationsAndPolicies-top-wrapper">
					<FormGroup
						labelSize={'col-sm-3'}
						inputSize={'col-sm-6'}
						label={CONTENT_STRINGS.NOTIFICATIONS_FILTER_STATUSES_LABEL}
						variant={FORM_GROUP_VARIANTS.MULTI_SELECT}
						inputProps={{
							instanceId: 'applicationStatuses',
							value: Store.selectedStatuses,
							isLoading: fetchingApplicationStatuses,
							onChange: selectApplicationStatus,
							options: statusesOptions,
							placeholder: CONTENT_STRINGS.QUICK_SEARCH,
						}}
						formGroupTestId={'notification-filter-application-statuses'}
					/>
					<FormGroup
						labelSize={'col-sm-3'}
						inputSize={'col-sm-6'}
						label={CONTENT_STRINGS.NOTIFICATIONS_FILTER_CASE_TYPES_LABEL}
						variant={FORM_GROUP_VARIANTS.MULTI_SELECT}
						inputProps={{
							instanceId: 'caseTypes',
							value: Store.selectedCaseTypes,
							isLoading: fetchingCaseTypes,
							onChange: selectCaseTypes,
							options: caseTypesOptions,
							placeholder: CONTENT_STRINGS.QUICK_SEARCH,
						}}
						formGroupTestId={'notification-filter-application-case-types'}
					/>
					{
						isAragUser 
						?
							<FormGroup
								labelSize={'col-sm-3'}
								inputSize={'col-sm-6'}
								label={CONTENT_STRINGS.NOTIFICATIONS_FILTER_NOTIFICATION_TYPE_LABEL}
								variant={FORM_GROUP_VARIANTS.MULTI_SELECT}
								inputProps={{
									instanceId: 'notificationTypes',
									value: Store.selectedNotificationTypes,
									isLoading: Store.fetchingNotificationTypes,
									onChange: selectNotificationTypes,
									options: notificationTypesOptions,
									placeholder: CONTENT_STRINGS.QUICK_SEARCH,
								}}
								formGroupTestId={'notification-filter-application-notification-type'}
							/>
						: 
							null
					}
					{
						(isAragUser && shouldDisplayUpdateFormQuestionsFilter()) 
						?
							<FormGroup
								labelSize={'col-sm-3'}
								inputSize={'col-sm-6'}
								label={CONTENT_STRINGS.NOTIFICATIONS_FILTER_UPDATE_FORM_QUESTIONS_LABEL}
								variant={FORM_GROUP_VARIANTS.MULTI_SELECT}
								inputProps={{
									instanceId: 'updateFormQuestions',
									value: Store.selectedUpdateFormQuestions,
									isLoading: fetchingUpdateFormQuestions,
									onChange: selectUpdateFormQuestions,
									options: updateFormQuestionOptions,
									placeholder: CONTENT_STRINGS.QUICK_SEARCH,
								}}
								formGroupTestId={'notification-filter-application-update-form-questions'}
							/>
						:
							null
					}
					<div className="form-group">
						<div className="col-sm-2">
							<FormGroup
								labelSize={'col-sm-4'}
								inputSize={'col-sm-8'}
								variant={FORM_GROUP_VARIANTS.SELECT}
								label={CONTENT_STRINGS.VIEW}
								inputProps={{
									id: `selectedView`,
									name: `selectedView`,
									value: Store.selectedView,
									onChange: (evt) => {
										HandleInputChange(evt.target.name, evt.target.value);
									},
									options: UI_LIB_TABLE_VIEW_OPTIONS,
								}}
								formGroupTestId={'notifications-view-control'}
							/>
						</div>
						<div className={'col-sm-6 col-sm-offset-1'}>
							<div style={{display: 'flex', gap: '10px'}}>
								<Button
									onClick={handleFilterClick}
									label={CONTENT_STRINGS.FILTER_LABEL}
									variant={PRIMARY}
									arrowDirection={RIGHT}
									buttonTestId={'notifications-filter'}
								/>
								<Button
									onClick={clearNotificationsFilters}
									label={CONTENT_STRINGS.CLEAR_FILTERS_LABEL}
									variant={QUATERNARY}
									arrowDirection={RIGHT}
									buttonTestId={'notifications-clear-filter'}
								/>
							</div>
						</div>
					</div>
					{
						(Store.fetching === false && !(Store.notifications.length > 0)) 
						?
							<FormGroup
								labelSize={'col-sm-12 col-sm-offset-5'}
								inputSize={''}
								label={CONTENT_STRINGS.NOTIFICATIONS_EMPTY_MESSAGE}
								variant={FORM_GROUP_VARIANTS.PLAIN}
								inputProps={{
									id: `noNotifications`,
									name: `noNotifications`,
								}}
								formGroupTestId={'notifications-no-notifications'}
							/>
						:
							Store.fetching 
							?
								<Loader variant="list" />
							:
								<div>
									<div style={{position: 'relative'}}>
										<HorizontalRule variant={DOTTED} />
										<OverlayIndicator
											fetching={Store.fetching && Store.notifications.length > 0}
											wholePage={false}
										/>
										{Store.notifications.map((item, index) => (
											<Notification
												onNotificationClick={onNotificationClick}
												getNotificationStatusText={getNotificationStatusText}
												item={item}
												key={item.id}
												index={index}
											/>
										))}
									</div>
									<Pager
										pageSize={parseInt(Store.selectedView)}
										totalItems={Store.totalRecords}
										totalPages={totalDisplayBoxes}
										page={Store.page || 1}
										goAtPrevious={goAtPrevious}
										goAtNext={goAtNext}
										goAtStart={goAtStart}
										goAtEnd={goAtEnd}
										goAtPage={goAtPage}
										pagerTestId={'notifications-pager'}
									/>
								</div>
					}
				</form>
			</div>
		</div>
	);
};

export default Notifications;
